<template>
  <div :class="['bg-white rounded-lg border p-4 flex flex-col gap-1', cardShadowClasses]">
    <span class="text-xs uppercase tracking-wide text-gray-brand-500 font-semibold">{{ label }}</span>
    <span class="text-2xl font-bold tracking-tight text-gray-brand-900">{{ value }}</span>
  </div>
</template>

<script>
import { cardShadowClasses } from '@/config'

export default {
  name: 'ResellerStatTile',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], required: true }
  },
  data() {
    return { cardShadowClasses }
  }
}
</script>
